import * as OpKinds from '../opKinds';
import * as Graph from '../graph';

const makeUserOp = OpKinds.makeStandardOp;

const userArgType = {
  user: 'user' as const,
};

const userArgDescription = `A ${Graph.docType('user')}`;

// None of these are correct yet, they need to handle nulls / mapped / tags
export const opUserId = makeUserOp({
  hidden: true,
  name: 'user-id',
  argTypes: userArgType,
  description: `Returns the internal id of the ${Graph.docType('user')}`,
  argDescriptions: {user: userArgDescription},
  returnValueDescription: `The internal id of the ${Graph.docType('user')}`,
  returnType: inputTypes => 'string',
  resolver: ({user}) => user.id,
});

export const opUserUsername = makeUserOp({
  name: 'user-username',
  argTypes: userArgType,
  description: `Returns the username of the ${Graph.docType('user')}`,
  argDescriptions: {user: userArgDescription},
  returnValueDescription: `The username of the ${Graph.docType('user')}`,
  returnType: inputTypes => 'string',
  resolver: ({user}) => user.username,
});

export const opUserName = makeUserOp({
  hidden: true,
  name: 'user-name',
  argTypes: userArgType,
  description: `Returns the name of the ${Graph.docType('user')}`,
  argDescriptions: {user: userArgDescription},
  returnValueDescription: `The name of the ${Graph.docType('user')}`,
  returnType: inputTypes => 'string',
  resolver: ({user}) => user.name,
});

export const opUserLink = makeUserOp({
  hidden: true,
  name: 'user-link',
  argTypes: userArgType,
  description: `Returns the link to the ${Graph.docType('user')}`,
  argDescriptions: {user: userArgDescription},
  returnValueDescription: `The link to the ${Graph.docType('user')}`,
  returnType: inputTypes => 'link',
  resolver: ({user}) => ({
    name: user.name,
    url: `/${user.username}`,
  }),
});

export const opUserRuns = makeUserOp({
  hidden: true,
  name: 'user-runs',
  argTypes: userArgType,
  description: `Returns the ${Graph.docType('list')} of ${Graph.docType('run', {
    plural: true,
  })} for the ${Graph.docType('user')}`,
  argDescriptions: {user: userArgDescription},
  returnValueDescription: `The ${Graph.docType('list')} of ${Graph.docType(
    'run',
    {plural: true}
  )} for the ${Graph.docType('user')}`,
  returnType: inputTypes => ({type: 'list', objectType: 'run'}),
  resolver: ({user}) => user.runs.edges.map((edge: any) => edge.node),
});

export const opUserEntities = makeUserOp({
  hidden: true,
  name: 'user-entities',
  argTypes: userArgType,
  description: `Returns the ${Graph.docType('list')} of ${Graph.docType(
    'entity',
    {plural: true}
  )} for the ${Graph.docType('user')}`,
  argDescriptions: {user: userArgDescription},
  returnValueDescription: `The ${Graph.docType('list')} of ${Graph.docType(
    'entity',
    {plural: true}
  )} for the ${Graph.docType('user')}`,
  returnType: inputTypes => ({type: 'list', objectType: 'entity'}),
  resolver: ({user}) => user.teams.edges.map((edge: any) => edge.node),
});
